export default __webpack_public_path__ + "static/media/exclamation.85474539.png";